import { flatMap, has } from "lodash";
import { useReducer } from "react";
import { toast } from "react-hot-toast";
import api from "../../apis/axiosInterceptor";

interface Master {
  allMemberData: any;
  allTeamMemberData: any;
  additionalPoint: any;
  allTeamMemberListData: any;
  getAllCalculateData: any;
  currentWeekData: any;
  getAllDashboardData: any;
  error: string;
  isImportSuccess: boolean;
  memberFilterData: any;
  developerSiteFilterData: object;
  allKymData: any;
  getAllWeekData: any;
  getAllTeamsData: any;
  getAllActivityData: any;
  getAllMemberTableData: any;
  getAllLeadershipTableData: any;
  getAllWeekWinnerData: any;
  getPointTableWeekData: any;
  getMemberTopWeekData: any;
}

const initialArgs: Master = {
  allMemberData: [],
  allTeamMemberData: [],
  additionalPoint: 0,
  allTeamMemberListData: [],
  getAllCalculateData: [],
  currentWeekData: [],
  allKymData: [],
  getAllDashboardData: [],
  getAllWeekData: [],
  getAllTeamsData: [],
  getAllActivityData: [],
  getAllMemberTableData: [],
  getAllLeadershipTableData: [],
  getAllWeekWinnerData: [],
  getPointTableWeekData: [],
  getMemberTopWeekData: [],
  error: "",
  isImportSuccess: false,
  memberFilterData: [],
  developerSiteFilterData: {},
};

const reducer = (state: Master, action: Master) => {
  return { ...state, ...action };
};

const useTeamMember = () => {
  const [state, setState] = useReducer(reducer, initialArgs);

  const clearState = () => {
    return { ...initialArgs };
  };
  const clearAllTeamMemberData = () => {
    setState({
      ...state,
      allTeamMemberData: [],
    });
  };

  const clearAllDashboardData = () => {
    setState({
      ...state,
      getAllDashboardData: [],
    });
  }; /* New GVS API Code Start */

  const getAllMember = async (weekId: string) => {
    try {
      let url = "/api/team/get-members?";

      if (weekId) url = url + `weekId=${weekId}`;

      const result: any = await api.get(url);

      if (result.data.status) {
        const filterData = result.data.data.map((item: any) => {
          return { ...item, id: item._id };
        });

        setState({
          ...state,
          allMemberData: filterData,
        });

        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };

  const getMemberTeamIdWise = async (
    teamId: string,
    weekId: string,
    memberId: string,
  ) => {
    try {
      const mId = memberId ? `&mId=${memberId}` : "";
      const result: any = await api.get(
        `/api/team/get/${teamId}?weekId=${weekId}${mId}`,
      );

      if (result.data.status) {
        setState({
          ...state,
          allTeamMemberData: result.data.data,
          additionalPoint: result.data.additionalPoint,
        });

        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };

  // const getAllKymList = async () => {
  //   try {
  //     const result: any = await api.get("/api/team/get-kym-members");

  //     if (result.data.status) {
  //       const filterKymData = result.data.data.map((item: any) => {
  //         return { ...item, id: item._id };
  //       });

  //       setState({
  //         ...state,
  //         allKymData: filterKymData,
  //       });

  //       return true;
  //     } else {
  //       const errorStr = has(result.data, "errors")
  //         ? Object(flatMap(result.data))[1].msg
  //         : result.data.message;
  //       setState({ ...state, error: errorStr });
  //       return false;
  //     }
  //   } catch (error: any) {
  //     setState({ ...state, error: error.message });
  //     return false;
  //   }
  // };

  const getAllMemberListData = async (teamId: string, weekId: string) => {
    try {
      const result: any = await api.get(
        `/api/team/week-result/${teamId}?weekId=${weekId}`,
      );

      if (result.data.status) {
        setState({
          ...state,
          allTeamMemberListData: result.data.data,
          additionalPoint: result.data.additionalPoint,
        });

        return result.data.data;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };

  /* New GVS API Code End */

  //Import UNIT API
  const importUnit = async (siteId: string, param: any) => {
    const paramObj = {
      file: param.files,
    };
    let resetImportToast;
    setState({ ...state, isImportSuccess: false });

    try {
      const result: any = await api.post(
        `/api/unit/import/${siteId}`,
        paramObj,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (result.data.status) {
        resetImportToast = toast.success(result.data.message, {
          id: resetImportToast,
        });
        setState({ ...state, isImportSuccess: true });
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr, { id: resetImportToast });
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message, { id: resetImportToast });
      setState({ ...state, error: error.message });
      return false;
    }
  };

  //Update Member
  const updateMember = async (memberId: string, param: any) => {
    const paramObj = {
      ...param,
    };

    try {
      const { data } = await api.put(`/api/member/${memberId}`, paramObj);

      if (data.status === true) {
        toast.success(data.message);
        return true;
      }
    } catch (error) {
      console.info("error => ", error);
      return false;
    }
  };

  const createTeamMember = async (param: any) => {
    try {
      const result: any = await api.post("/api/team/member-activity", param);

      if (result.data.status) {
        toast.success(result.data.message);
        setState({ ...state });
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      setState({ ...state, error: error.message });
      return false;
    }
  };

  const CalculationTotalTeamPoints = async (param: any) => {
    try {
      const result: any = await api.post(
        "/api/team/team-correction-point",
        param,
      );

      if (result.data.status) {
        toast.success(result.data.message);
        setState({ ...state });
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      setState({ ...state, error: error.message });
      return false;
    }
  };

  const getCurrentWeek = async () => {
    try {
      const result: any = await api.get(`/api/team/current-week`);

      if (result.data.status) {
        setState({
          ...state,
          currentWeekData: result.data.data,
        });

        return result.data.data;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };

  const getCalculateData = async (
    teamId: string,
    weekId: string,
    teamPoint: string,
    create: boolean,
  ) => {
    try {
      const result: any = await api.get(
        `/api/team/week-activity/${teamId}?weekId=${weekId}&teamPoint=${teamPoint}&checkPoint=${create}`,
      );

      if (result.data.status) {
        setState({
          ...state,
          getAllCalculateData: result.data.data,
        });

        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };
  const getWeeksData = async () => {
    try {
      const result: any = await api.get(`/api/activity/get-week`);

      if (result.data.status) {
        return result.data.data;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };

  const getTeamDashboard = async (teamId: string, weekId: string) => {
    try {
      const result: any = await api.get(
        `/api/team/get-top-members/${teamId}?weekId=${weekId}`,
      );

      if (result.data.status) {
        setState({
          ...state,
          getAllDashboardData: result.data.data,
        });

        return result.data.data;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };

  const getAllWeeksAPI = async () => {
    try {
      const result: any = await api.get(`/api/activity/get-week`);

      if (result.data.status) {
        const filterData = result.data.data.map((item: any, index: any) => {
          return { ...item, id: parseInt(index), name: item.week };
        });
        setState({
          ...state,
          getAllWeekData: filterData,
        });
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        //setState({ ...state, error: errorStr });
        toast.error(errorStr);

        return false;
      }
    } catch (error: any) {
      //setState({ ...state, error: error.message });
      return false;
    }
  };

  const downloadMemberResults = async (teamId: string, weekId: string) => {
    try {
      const result = await api.get(
        `/api/team/export-results/${teamId}?weekId=${weekId}`,
      );
      return result;
    } catch (error: any) {
      if (
        error.response &&
        error.response.status !== 402 &&
        error.response.status !== 404
      ) {
        toast.error("Error while fetching Member results for export");
      }
    }
  };

  const getAllTeamsAPI = async () => {
    try {
      const result: any = await api.get(`/api/team/get-all-teams`);

      if (result.data.status) {
        const filterTeamData = result.data.data.map((item: any, index: any) => {
          return { ...item, id: parseInt(index), name: item.teamName };
        });
        setState({
          ...state,
          getAllTeamsData: filterTeamData,
        });
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        //setState({ ...state, error: errorStr });
        toast.error(errorStr);

        return false;
      }
    } catch (error: any) {
      //setState({ ...state, error: error.message });
      return false;
    }
  };

  const getAllActivityApi = async (teamId: string) => {
    try {
      const selectTeamId = teamId ? `?teamId=${teamId}` : "";
      const result: any = await api.get(
        `/api/team/activity-coins${selectTeamId}`,
      );

      if (result.data.status) {
        setState({
          ...state,
          getAllActivityData: result.data.data,
        });

        return result.data.data;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };

  /* Winners API Start  */
  const getAllWeekWinnersApi = async (winWeekId: string) => {
    try {
      const result: any = await api.get(`/api/team/winner-week/${winWeekId}`);

      if (result.data.status) {
        setState({
          ...state,
          getAllWeekWinnerData: result.data.data,
        });

        return result.data.data;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };
  /* Winners API End  */

  /* Points Table API Start */
  const getPointTableWeekApi = async (pointTableWeekId: string) => {
    try {
      const result: any = await api.get(
        `/api/team/points-table/${pointTableWeekId}`,
      );

      if (result.data.status) {
        setState({
          ...state,
          getPointTableWeekData: result.data.data,
        });

        return result.data.data;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };
  /* Points Table API End*/

  /* Top 10 Member API Start  */
  const getMemberTopWeekApi = async (memberTopWeekId: string) => {
    try {
      const result: any = await api.get(
        `/api/team/week-top-members/${memberTopWeekId}`,
      );

      if (result.data.status) {
        setState({
          ...state,
          getMemberTopWeekData: result.data.data,
        });

        return result.data.data;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };
  /* Top 10 Member API End  */

  /* Member LeaderShip API Start */
  const getAllMemberListTableApi = async (teamId: string) => {
    try {
      const selectedTeamId = teamId ? `?teamId=${teamId}` : "";
      const result: any = await api.get(
        `/api/team/members-table-weeks${selectedTeamId}`,
      );

      if (result.data.status) {
        setState({
          ...state,
          getAllMemberTableData: result.data.data,
        });

        return result.data.data;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };
  /* Member LeaderShip API End */

  /* Leadership Table API Start */
  const getAllLeadershipTableApi = async () => {
    try {
      const result: any = await api.get(`/api/team/teams-table-weeks`);

      if (result.data.status) {
        setState({
          ...state,
          getAllLeadershipTableData: result.data.data,
        });

        return result.data.data;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };
  /* Leadership Table API End */

  /* Export Leadership Table API Start  */
  const downloadLeadershipResults = async () => {
    try {
      const result = await api.get(`/api/team/export-teams-table`);
      return result;
    } catch (error: any) {
      if (
        error.response &&
        error.response.status !== 402 &&
        error.response.status !== 404
      ) {
        toast.error("Error while fetching Leadership results for export");
      }
    }
  };
  /* Export Leadership Table API End  */

  /* Export Members Leadership Table API Start */
  const downloadAllMemberTableResults = async (teamId: string) => {
    try {
      const selectedTeamId = teamId ? `?teamId=${teamId}` : "";
      const result = await api.get(
        `/api/team/export-members-table${selectedTeamId}`,
      );
      return result;
    } catch (error: any) {
      if (
        error.response &&
        error.response.status !== 402 &&
        error.response.status !== 404
      ) {
        toast.error("Error while fetching Member results for export");
      }
    }
  };
  /* Export Members Leadership Table API End */

  return {
    importUnit,
    updateMember,
    // New GVS Code Start
    getAllMember,
    getMemberTeamIdWise,
    // getAllKymList,
    createTeamMember,
    getCurrentWeek,
    getAllMemberListData,
    getCalculateData,
    getTeamDashboard,
    getWeeksData,
    getAllWeeksAPI,
    downloadMemberResults,
    clearState,
    getAllTeamsAPI,
    clearAllTeamMemberData,
    clearAllDashboardData,
    getAllActivityApi,
    getAllWeekWinnersApi,
    getPointTableWeekApi,
    getMemberTopWeekApi,
    getAllMemberListTableApi,
    getAllLeadershipTableApi,
    downloadLeadershipResults,
    downloadAllMemberTableResults,
    CalculationTotalTeamPoints,
    // New GVS Code End
    ...state,
  };
};

export default useTeamMember;
